import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import NavBar from "../../../components/navbar/NavBar";
import axios from "axios";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import messages from "../../../constants/messages";
import IDL from "../../../constants/token_idl.json";
import { Program, BN, AnchorProvider } from "@coral-xyz/anchor";
import { connection } from "../../../constants/constants";
import { Transaction, PublicKey, SystemProgram } from "@solana/web3.js";
import useLocalWallet from "../../../utils/hooks";
import { useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import {
  getAssociatedTokenAddress,
  createAssociatedTokenAccountInstruction,
  TOKEN_PROGRAM_ID,
  ASSOCIATED_TOKEN_PROGRAM_ID,
} from "@solana/spl-token";
import useContractInit from "../../../utils/hooks/contractInit";
import useGetTokenQuantity from "../../../utils/hooks/getGoesOutToken";

const AdminWithdrawalToken = () => {
  const {
    connected,
    walletAddress,
    balance,
    isOpen,
    setIsOpen,
    handleRightToggle,
    copyAccountToClipboard,
  } = useLocalWallet();
  const wallet = useWallet();

  const {
    tokenSaleConfigAddress,
    tokenMintAddress,
    saleAuthority,
    deploymentWalletAddress,
    getTokenInitializationDetails,
  } = useContractInit();

  const { currentSlot, loadingState, totalBuyable, getGoesOutToken } =
    useGetTokenQuantity();

  const [inputToken, setInputToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  const REACT_APP_EXPLORER_BASE_URL = process.env.REACT_APP_EXPLORER_BASE_URL;
  const REACT_APP_TOKEN_ENVIRONMENT = process.env.REACT_APP_TOKEN_ENVIRONMENT;

  const displayableBuyable = currentSlot === null ? 0 : totalBuyable;

  const [program, setProgram] = useState(null);

  const transaction = new Transaction();

  // Initialize Anchor program
  useEffect(() => {
    const initializeProgram = async () => {
      if (wallet) {
        try {
          const provider = new AnchorProvider(connection, wallet, {
            commitment: "confirmed",
          });

          const programInstance = new Program(IDL, provider);
          setProgram(programInstance);
          // getGoesOutToken();
        } catch (error) {
          console.error("Error creating Program: ", error);
        }
      } else {
        return;
      }
    };

    initializeProgram();
  }, []);

  const handleSubmit = async () => {
    if (inputToken === "" || inputToken === null || inputToken === undefined) {
      setError(messages.errors.tokenQuantityRequired);
      return;
    }
    if (inputToken <= 0) {
      setError(messages.errors.errorTokenQuantity);
      return;
    }
    const connectedWallet = wallet?.publicKey?.toBase58();
    if (deploymentWalletAddress !== connectedWallet) {
      Swal.fire({
        title: "Wallet Mismatch",
        text: "The connected wallet doesn't match the wallet used during token creation. please connect the same wallet to proceed with token withdrawal.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      setLoading(true);
      setError("");
      const [programTokenAccount, programTokenAccountInstruction] =
        await getAssociatedTokenAccount(
          tokenMintAddress,
          saleAuthority,
          wallet.publicKey
        );

      if (programTokenAccountInstruction) {
        transaction.add(programTokenAccountInstruction);
      }

      const [admintTokenAccount, adminTokenAccountInstruction] =
        await getAssociatedTokenAccount(
          tokenMintAddress,
          wallet.publicKey,
          wallet.publicKey
        );

      if (adminTokenAccountInstruction) {
        transaction.add(adminTokenAccountInstruction);
      }

      const [monthlyLimitsAccount, monthlyLimitsBump] =
        PublicKey.findProgramAddressSync(
          [Buffer.from("monthly_limits_a")],
          program.programId
        );

      console.log(
        "The monthly limits account value is: ",
        monthlyLimitsAccount.toBase58()
      );

      const remTokens = await program.account.monthlyLimits.fetch(
        monthlyLimitsAccount
      );

      //This value gives the reaminig tokens in the contract
      let rem = remTokens.tokensAvailable;

      let totalUnlocked = remTokens.tokensUnlocked;

      console.log(
        "Total tokens that are goes-Out (buy+wdl)uptill this point: ",
        totalUnlocked.toNumber() / 1e6
      );

      console.log(
        "Current Tokens available at this point are (Max Buyable from user end): ",
        rem.toNumber() / 1e6
      );

      let input = new BN(inputToken * 1000000);

      if (input > rem) {
        console.log("Tokens Eceed limit");
        // return;
      }

      const tx = await program.methods
        .withdrawTokens(input)
        .accounts({
          saleConfig: tokenSaleConfigAddress,
          authority: wallet.publicKey,
          monthlyLimits: monthlyLimitsAccount,
          programTokenAccount: programTokenAccount,
          programSaleAuthority: saleAuthority,
          mint: tokenMintAddress,
          admintTokenAccount: admintTokenAccount,
          systemProgram: SystemProgram.programId,
          tokenProgram: TOKEN_PROGRAM_ID,
          associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
        })
        .instruction();

      transaction.add(tx);

      let recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
      transaction.recentBlockhash = recentBlockhash;

      transaction.feePayer = wallet.publicKey;

      const signature = await window.solana.signAndSendTransaction(transaction);

      await connection.confirmTransaction(signature.signature, "confirmed");

      const newRemTokens = await program.account.monthlyLimits.fetch(
        monthlyLimitsAccount
      );

      //This value gives the reaminig tokens in the contract
      let newRem = newRemTokens.tokensAvailable;

      console.log("The new updates state is: ", newRem.toNumber() / 1e6);

      const _sign = signature?.signature;

      console.log("Tx successful: ", _sign);
      const details = await getTransactionDetails(_sign);
      details.adminId = user.userId;
      details.tokenQuantity = inputToken;
      await sendTransactionDetails(details);
      await getGoesOutToken();
      setLoading(false);
      setInputToken("");
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: `Error: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading(false);
      console.log("Error Withdrawing funds ", error);
    }
  };

  const getAssociatedTokenAccount = async (mint, owner, payer) => {
    let tokenAccountAddress = await getAssociatedTokenAddress(
      mint,
      owner,
      true
    );

    const accountInfo = await connection.getAccountInfo(tokenAccountAddress);
    if (accountInfo !== null) {
      return [tokenAccountAddress, null];
    }

    let tokenAccountCreationInstruction =
      createAssociatedTokenAccountInstruction(
        payer,
        tokenAccountAddress,
        owner,
        mint
      );
    return [tokenAccountAddress, tokenAccountCreationInstruction];
  };

  const getTransactionDetails = async (signature) => {
    try {
      const transaction = await connection.getTransaction(signature, {
        maxSupportedTransactionVersion: 0,
      });
      const status = await getTransactionStatus(signature);
      if (transaction) {
        return {
          transactionId: signature,
          status,
        };
      }
    } catch (error) {
      console.error("Failed to get Tx details: ", error);
    }
  };

  const getTransactionStatus = async (signature) => {
    try {
      const status = await connection.getSignatureStatus(signature);

      if (status?.value?.err === null) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error("Transaction failed");
    }
  };

  const sendTransactionDetails = async (details) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/admin/storeWithdrawalToken`,
        details,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const signature = response.data.data;
      Swal.fire({
        title: `${response.data.message}`,
        icon: response.data.status === 200 ? "success" : "error",
        showCancelButton: true,
        cancelButtonText: "Close",
        confirmButtonText: "Check on Explorer",
      }).then((result) => {
        if (result.isConfirmed) {
          if (!signature) {
            console.error("Signature not available");
            return;
          }
          const url = `${REACT_APP_EXPLORER_BASE_URL}tx/${signature}?cluster=${REACT_APP_TOKEN_ENVIRONMENT}`;

          window.open(url, "_blank", "noopener,noreferrer");
        }
      });
    } catch (error) {
      console.error("Error sending transaction details:", error);
      Swal.fire({
        title: "Error!",
        text: `Error: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getTokenInitializationDetails();
  }, []);

  useEffect(() => {
    if (!loadingState && totalBuyable) {
      getGoesOutToken();
    }
  }, [loadingState, totalBuyable]);

  const handleConnectWallet = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen === true ? "active" : ""}`}>
        <section id="content-wrapper">
          <h4 className="my-dash main-head widthdrawl-heading">
            Withdraw Tokens
          </h4>
          <div className="running-token">
            {!loadingState && totalBuyable ? (
              <p>Available tokens in Slot : {displayableBuyable} $LAL</p>
            ) : (
              ""
            )}
          </div>
          <div className="right-sidebar">
            <div className="right-sidebar-inner">
              <nav className="navbar navbar-expand-lg navbar-light">
                <div className="right-toggle-menu-outer">
                  <div className="right-toggle-menu">
                    <div
                      className="right-toggle-menu-inner"
                      onClick={handleRightToggle}
                    >
                      <div className="wallent">
                        {connected && walletAddress ? (
                          <button className="btn btn-one">
                            {walletAddress.substring(0, 4)}...
                            {walletAddress.slice(-4)}
                          </button>
                        ) : (
                          <button className="btn btn-two">Connect</button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
              <div
                className={`right-sidebar ${isOpen === true ? "active" : ""}`}
              >
                <div className="sd-header">
                  <div className="sd-header-btn" onClick={handleRightToggle}>
                    <i className="fa fa-times"></i>
                  </div>
                </div>
                <div className="sd-body">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="connect-card">
                        <div className="card-body">
                          <div className="card-inner">
                            <div className="wallet-ui">
                              <div className="wallet-add">
                                <h6
                                  className={`wallet-address ${
                                    connected && walletAddress
                                      ? "wallet-connected"
                                      : "wallet-disconnected"
                                  }`}
                                >
                                  {connected && walletAddress
                                    ? "Wallet Address "
                                    : ""}
                                  {connected && walletAddress
                                    ? `${walletAddress.substring(
                                        0,
                                        4
                                      )}...${walletAddress.slice(-4)}`
                                    : "Wallet not connected"}
                                </h6>
                                {connected && walletAddress ? (
                                  <Tooltip title="Copy Wallet Address" arrow>
                                    <FontAwesomeIcon
                                      icon={faCopy}
                                      className="admin-lfc-deposit-copy"
                                      onClick={copyAccountToClipboard}
                                    />
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="admin-lfc-deposit-balance">
                                {connected ? (
                                  <p>Balance: {balance} SOL</p>
                                ) : (
                                  <p>Balance: 0 SOL</p>
                                )}
                              </div>
                              <WalletMultiButton />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`sidebar-overlay ${isOpen === true ? "active" : ""}`}
                onClick={handleRightToggle}
              ></div>
            </div>
          </div>
          <div className="user-dashboard-inner">
            <div className="user-dashboard-tab">
              <div className="container">
                <div className="user-dashboard-tab-inner">
                  <Tabs
                    defaultActiveKey="limit"
                    id="uncontrolled-tab-example"
                    className=""
                  >
                    <Tab eventKey="limit" title="Withdraw Tokens">
                      <div className="user-dash-tab-form">
                        <Form.Label>
                          Token Quantity<span>*</span>
                        </Form.Label>
                        <InputGroup className="">
                          <Form.Control
                            type="number"
                            name="token"
                            aria-label="Number input with dropdown button"
                            value={inputToken}
                            onChange={(e) => {
                              setInputToken(e.target.value);
                              setError("");
                            }}
                            placeholder="Enter Token Quantity"
                            required
                          />
                        </InputGroup>
                      </div>
                      {connected ? (
                        <div className="connect-wallet-one">
                          <Button onClick={handleSubmit} disabled={loading}>
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      ) : (
                        <div className="connect-wallet-one">
                          <button onClick={handleConnectWallet}>
                            Connect Wallet
                          </button>
                        </div>
                      )}
                      <div className="error-limit">{error}</div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminWithdrawalToken;
